export default "__VITE_ASSET__6de48b44__"